// Module
var code = "<div class=\"dimension-item\"> <div class=\"dimension-name\"><span class=\"label{{classLabel}}\">{{label}}</span><span class=\"value\">{{value}}</span></div> <div class=\"dimension-values\">{{values}}</div> </div>";
// Exports
module.exports = code;